//搬出管理
export default [
  {
    path: '/memberCategory',
    component: () => import('../pages/memberManage/memberCategory.vue'),
    name: 'memberCategory',
    title: '会员卡分类管理',
    meta: {
      title: '会员卡分类管理',
    },
  },
  {
    path: '/memberManage',

    component: () => import('../pages/memberManage/memberManage.vue'),
    name: 'memberManage',
    title: '权益类型',
    meta: {
      title: '权益类型',
    },
  },
  {
    path: '/discountManage',

    component: () => import('../pages/memberManage/discountManage.vue'),
    name: 'discountManage',
    title: '权益明细',
    meta: {
      title: '权益明细',
    },
  },
  {
    path: '/memberUntie',
    component: () => import('../pages/memberManage/memberUntie.vue'),
    name: 'memberUntie',
    title: '会员卡解绑',
    meta: {
      title: '会员卡解绑',
    },
  },

  // 大会员积分相关
  {
    path: '/userBadgeManage',
    component: () => import('../pages/memberManage/megaMember/userBadge/userBadge.vue'),
    name: 'userBadgeManage',
    title: '用户徽章管理',
    meta: {
      title: '用户徽章管理',
    },
  },
  {
    path: '/scoreAudit',
    component: () => import('../pages/memberManage/megaMember/scoreAudit/scoreAudit.vue'),
    name: 'scoreAudit',
    title: '自助积分审核',
    meta: {
      title: '自助积分审核',
    },
  },
  {
    path: '/userTask',
    component: () => import('../pages/memberManage/megaMember/userTask/userTask.vue'),
    name: 'userTask',
    title: '用户任务配置',
    meta: {
      title: '用户任务配置',
    },
  },
  {
    path: '/userBadgeTask',
    component: () => import('../pages/memberManage/megaMember/userBadge/userBadgeTask.vue'),
    name: 'userBadgeTask',
    title: '徽章任务配置',
    meta: {
      title: '徽章任务配置',
    },
  },
  {
    path: '/memberRights',
    component: () => import('../pages/memberManage/megaMember/memberRights/memberRights.vue'),
    name: 'memberRights',
    title: '权益配置',
    meta: {
      title: '权益配置',
    },
  },
  {
    path: '/receiveLog',
    component: () => import('../pages/memberManage/megaMember/receiveLog/receiveLog.vue'),
    name: 'receiveLog',
    title: '徽章领取记录',
    meta: {
      title: '徽章领取记录',
    },
  },
  {
    path: '/paymentRuleConfig',
    component: () => import('../pages/memberManage/megaMember/paymentRuleConfig/paymentRuleConfig.vue'),
    name: 'paymentRuleConfig',
    title: '消费积分规则配置',
    meta: {
      title: '消费积分规则配置',
    },
  },
  {
    path: '/merchantBaseConfigSetting',
    component: () => import('../pages/memberManage/megaMember/merchantSetting/merchantSetting.vue'),
    name: 'merchantBaseConfigSetting',
    title: '商户基础配置',
    meta: {
      title: '商户基础配置',
    },
  },
  {
    path: '/merchantAccountManage',
    component: () => import('../pages/memberManage/megaMember/merchantSetting/merchantAccountManage.vue'),
    name: 'merchantAccountManage',
    title: '商户管理员配置',
    meta: {
      title: '商户管理员配置',
    },
  },

]
